module.exports = __webpack_public_path__ + "static/media/NotoSansJP-Bold.1bdb5bf9.ttf";